import React, { useEffect, useState, useRef } from "react";
import { Slider } from "@mui/material";
import { isArray } from "lodash";
import { useSelector } from "react-redux";
import { t } from "i18next";

import { getButtonBgColor, getIsMaximized } from "slices";
import { formatCurrency } from "components/UnitsView/utils";
import { ButtonComp } from "components";

const RangeSlider = ({ range, onSelect, customBudget }) => {
  const [value, setValue] = useState(customBudget || range);
  const [isOverlapping, setIsOverlapping] = useState(false);

  const sliderWrapperRef = useRef(null);
  const backgroundColor = useSelector(getButtonBgColor);
  const isMaximized = useSelector(getIsMaximized);

  // Detect overlap
  useEffect(() => {
    const wrapper = sliderWrapperRef.current;

    if (!wrapper) {
      return;
    }

    const checkOverlap = () => {
      const thumbs = wrapper.querySelectorAll(".MuiSlider-thumb");

      if (thumbs.length < 2) {
        return;
      }

      const [thumb1, thumb2] = thumbs;
      const rect1 = thumb1.getBoundingClientRect();
      const rect2 = thumb2.getBoundingClientRect();

      const distance = Math.abs(rect1.left - rect2.left);

      setIsOverlapping(distance < 40);
    };

    // Observe size changes
    const resizeObserver = new ResizeObserver(checkOverlap);
    resizeObserver.observe(wrapper);

    checkOverlap();

    return () => resizeObserver.disconnect();
  }, [value]);

  const handleChange = (event, newValue, activeThumb) => {
    if (!isArray(newValue)) {
      return;
    }

    setValue(newValue);
  };

  const disabled = false;

  const style = {
    "& .MuiSlider-thumb": {
      color: "#fff",
    },
    "& .MuiSlider-track": {
      color: backgroundColor,
    },
    "& .MuiSlider-valueLabel": {
      top: "50px", // Adjust the vertical position
      background: "none",
      color: "#333",
      fontWeight: "normal !important",
    },
    // First thumb label (start)
    '& .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
      top: "50px",
    },
    // Second thumb label (end) — move it down if overlap
    '& .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': {
      top: isOverlapping ? "66px" : "50px",
    },
    height: 4,
  };

  return (
    <>
      <div
        data-testid="range-slider"
        className={`${
          isMaximized ? "hayley-flex hayley-w-full hayley-flex-wrap hayley-items-center hayley-space-x-5 lg:hayley-flex-nowrap" : "hayley-w-full"
        } hayley-rounded-lg hayley-border hayley-border-solid hayley-border-custom-6 hayley-p-4`}
      >
        {/* <span className="hayley-text-sm hayley-font-normal">{t("selectBudgetRange")}</span> */}
        <div className="hayley-my-1 hayley-flex hayley-w-[90%] hayley-items-center hayley-justify-between hayley-px-3 lg:hayley-w-full">
          <div className=" hayley-w-full">
            <div className=" hayley-flex hayley-justify-between hayley-pt-4 hayley-text-secondary/50">
              <span className="hayley-text-xs hayley-font-bold ">{formatCurrency(range[0])}</span>
              <span className="hayley-text-xs hayley-font-bold ">{formatCurrency(range[1])}</span>
            </div>
            <div className=" hayley-mx-2 hayley-h-16" ref={sliderWrapperRef}>
              <Slider
                getAriaLabel={() => "Minimum distance shift"}
                value={value}
                onChange={handleChange}
                valueLabelDisplay="on"
                disableSwap
                min={range[0]}
                max={range[1]}
                valueLabelFormat={formatCurrency}
                sx={style}
                step={50}
              />
            </div>
          </div>
        </div>
        <ButtonComp testId="confirm-budget" className="hayley-min-w-fit" onClick={() => onSelect(value)} label={t("confirmBudget")} disabled={disabled} />
      </div>
    </>
  );
};

export default RangeSlider;
